// mobile menu open close
const menuToggle = document.querySelector(".toggle");
const mobileMenu = document.querySelector(".mobile-menu");
const scroll_block = document.querySelector("html");

menuToggle.onclick = function () {
  menuToggle.classList.toggle("active");
  mobileMenu.classList.toggle("menu-open");
  scroll_block.classList.toggle("scroll-lock");
};

window.addEventListener("scroll", function () {
  const header = document.querySelector("header");
  if (window.scrollY >= 120) {
    header.classList.add("sticky-header");
  } else {
    header.classList.remove("sticky-header");
  }
});
